import { createAsyncThunk } from '@reduxjs/toolkit';
import { setError, setMessage } from '../../../redux/slice';

import * as api from '../api';

export const doGetProviderIntegrations = createAsyncThunk(
  'providerIntegrations/doGetProviderIntegrations',
  async (params, thunkAPI) => {
    console.log({ params });
    try {
      const { response, error } = await api.getProviderIntegrations(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doGetProviderIntegration = createAsyncThunk(
  'providerIntegrations/doGetProviderIntegration',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.getProviderIntegration(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doCreateProviderIntegration = createAsyncThunk(
  'providerIntegrations/doCreateProviderIntegration',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.createProviderIntegration(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doUpdateProviderIntegration = createAsyncThunk(
  'providerIntegrations/doUpdateProviderIntegration',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.updateProviderIntegration(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doDeleteProviderIntegration = createAsyncThunk(
  'providerIntegrations/doDeleteProviderIntegration',
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.deleteProviderIntegration(params);
      if (error) {
        thunkAPI.dispatch(setError(error));
        return thunkAPI.rejectWithValue(error);
      } else {
        thunkAPI.dispatch(setMessage('Your action has been completed successfully'));
        return response;
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

// export const doTestVeloyd = createAsyncThunk('integrations/doTestVeloyd', async (params, thunkAPI) => {
//   try {
//     const { response, error } = await api.testVeloyd(params);
//     return error ? thunkAPI.rejectWithValue(error) : response;
//   } catch (e) {
//     thunkAPI.rejectWithValue(e);
//     throw e;
//   }
// });
